import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CustomLoaderService {
  visible: boolean;
  Newvisible: boolean;
  HideMenus: boolean;
  HideAllMenus: boolean;
  ReportLoaderVisible: boolean;

  constructor() { this.visible = false; this.Newvisible = false; this.HideMenus = false; 
  setTimeout(() => {
    if (sessionStorage.getItem("@ssdhg$hwhy3u#a8bf") != null && sessionStorage.getItem("@ssdhg$hwhy3u#a8bf") != undefined && sessionStorage.getItem("@ssdhg$hwhy3u#a8bf") != "") { 
      this.HideAllMenus = true;
    }

    if (sessionStorage.getItem("dfrs980f9vdfug") != null && sessionStorage.getItem("dfrs980f9vdfug") != undefined && sessionStorage.getItem("@ssdhg$hwhy3u#a8bf") != "") { 
      this.HideMenus = true;
    }
  }, 100); }
  hide() { this.visible = false; }
  show() { this.visible = true; }

  hideNew() { this.Newvisible = false; }
  showNew() { this.Newvisible = true; }

  hideMenu() { this.HideMenus = true; }

  hideAllMenus() { this.HideAllMenus = true; }

  ReportLoaderhide() { this.ReportLoaderVisible = false; }
  ReportLoadershow() { this.ReportLoaderVisible = true; }

}
